/**
 * zeluslugi.ru
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2018 delphinpro
 * @license     licensed under the MIT license
 */

const isProduction = process.env.NODE_ENV === 'production';

export const CALC_DISPLAY_AS_MINI = isProduction ? 1 : 'MINI';
export const CALC_DISPLAY_AS_FULL = isProduction ? 2 : 'FULL';

export const CALC_DISPLAY_MODE_COMPACT = true;
export const CALC_DISPLAY_MODE_DETAILS = false;
export const CALC_DISPLAY_MORE_1 = false;
export const CALC_DISPLAY_MORE_2 = false;

export const EMERGENCY_TEXT_0 = 'Неограниченное количество выездов, прибытие на следующий рабочий день';
export const EMERGENCY_TEXT_1 = 'Неограниченное количество выездов, прибытие в течение 4 часов';
export const EMERGENCY_TEXT_2 = 'Неограниченное количество выездов, прибытие в течение 2 часов';
